(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-components/assets/javascripts/web-text.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-components/assets/javascripts/web-text.js');
"use strict";

const Coupon = svs.components.tipsen.couponComponents.Coupon;
const WebText = _ref => {
  let _ref$eventComment = _ref.eventComment,
    eventComment = _ref$eventComment === void 0 ? '' : _ref$eventComment;
  return React.createElement("div", {
    className: "pg_web_text"
  }, eventComment);
};
Coupon.WebText = WebText;

 })(window);